import Big from 'big.js';
import { VIEW_STATUS } from 'constants/orders';

export function isOpenOrder(orderEvents) {
  return !orderEvents.closedAt && !orderEvents.rejectedAt;
}

export function isClosedOrder(orderEvents) {
  return orderEvents.closedAt || orderEvents.rejectedAt;
}

export function getFillsQuantitySum(order) {
  const bigSum = order.fills.reduce((quantitySum, fill) => quantitySum.plus(fill.quantity), new Big(0));
  return bigSum.toNumber();
}

export function orderDataToStatus(order) {
  if (order.events.createdAt && !order.events.openedAt && !order.events.closedAt && !order.events.rejectedAt)
    return VIEW_STATUS.CREATED;
  if (order.events.rejectedAt) return VIEW_STATUS.REJECTED;
  if (order.events.createdAt && order.events.openedAt && !order.events.closedAt && !order.events.rejectedAt) {
    if (order.fills.length === 0) {
      return VIEW_STATUS.OPEN;
    }
    return VIEW_STATUS.PARTIALLY_FILLED_OPEN;
  }

  if (order.events.closedAt) {
    const filledQuantity = getFillsQuantitySum(order);

    if (filledQuantity === 0) {
      return VIEW_STATUS.CLOSED;
    }
    if (filledQuantity < +order.quantity) {
      return VIEW_STATUS.PARTIALLY_FILLED_CLOSED;
    }
    if (filledQuantity === +order.quantity) {
      return VIEW_STATUS.COMPLETED;
    }
  }

  throw new Error(`Can't get status for events: ${JSON.stringify(order)}`);
}

export function orderIsNotCancellable(orderEvents) {
  return orderEvents.closedAt || orderEvents.rejectedAt;
}
